import type { PricebookVendorCost } from "./pricebook-vendor-costs";
export type VendorCosts = { vendorCosts?: PricebookVendorCost[] };
export function purchaseCost(item: VendorCosts & { costCents: number | null }, vendorId?: string) {
  if (item.vendorCosts?.length) return item.vendorCosts.find(cost => cost.vendorId === vendorId && cost.active !== false)?.costCents ?? null;
  return item.costCents;
}
